import Vue from 'vue'
import Vuex from 'vuex'
import api from '@/api'
import order from './modules/order'
import swebPublic from './modules/swebPublic'
import signImage from './modules/signImage'
import bill from './modules/bill'
import adjustOrder from './modules/adjustOrder'
import finance from './modules/finance'
import price from './modules/price'
import mergeInvoice from './modules/mergeInvoice'
import certManage from './modules/certManage'
import helpCenter from './modules/helpCenter'
import directOrder from './modules/directOrder'
import piaoYiTong from './modules/piaoYiTong'
// import supplierVisit from './modules/visit'
import goodsCert from './modules/goodsCert'
import paperInvoice from './modules/paperInvoice'
import supplierPool from './modules/supplierPool'
import goods from './modules/goods'
import serviceReceipt from './modules/serviceReceipt'

const debug = process.env.NODE_ENV !== 'production'

Vue.use(Vuex)
Vue.config.devtools = debug

const state = {
  suppliers: [],
  frameSuppliers: [],
  loginSupplier: {},
  // loginFrameSupplier: {},
  activeMenu: '',
  isJiajiayuan: false
  // isFirstRoute: true
}

const mutations = {
  setSuppliers (state, data) {
    state.suppliers = data || []
  },
  setFrameSuppliers (state, data) {
    state.frameSuppliers = data || []
  },
  setLoginSupplier (state, data) {
    state.loginSupplier = data || {}
    const serviceUnitIds = [4708885, 13884937, 4746569, 7829299, 66002438]
    state.isJiajiayuan = (serviceUnitIds.indexOf(data.serviceUnitId) > -1)
  },
  // setLoginFrameSupplier (state, data) {
  //   state.loginFrameSupplier = data || {}
  // },

  // 【美农一二级订单】
  // 经营单元名称：北京谷田科技有限公司 线上：经营单元id   7829299  stage：经营单元id  4746569
  // 武汉家家源 线上：经营单元id   4708885  stage：经营单元id  4708885
  setActiveMenu (state, data) {
    state.activeMenu = data || ''
  }
  // setIsFirstRoute (state) {
  //   state.isFirstRoute = false
  // }
}

const actions = {
  // 获取业务城市
  listBizCity ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.listBizCity(data).then(res => {
        let resData = res.data
        if (resData.ret === 1) {
          resolve(resData)
        } else {
          reject({ from: '/sweb/public/listBizCity', error: resData })
        }
      }).catch(e => {
        reject({from: '/sweb/public/listBizCity', error: {code: 0, msg: '网络异常，请稍后再试'}})
      })
    })
  },
  // 获取供应商城市 目前用于账单管理、合并开票中的城市下拉框
  listSupplierCity ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.listSupplierCity(data).then(res => {
        let resData = res.data
        if (resData.ret === 1) {
          resolve(resData)
        } else {
          reject({ from: '/sweb/public/listSupplierCity', error: resData })
        }
      }).catch(e => {
        reject({from: '/sweb/public/listSupplierCity', error: {code: 0, msg: '网络异常，请稍后再试'}})
      })
    })
  },
  getUserInfo ({ commit, dispatch }) {
    return new Promise((resolve, reject) => {
      api.getUserInfo().then(res => {
        let resData = res.data
        if (resData.ret === 1 && resData.data) {
          commit('setLoginSupplier', resData.data)
          resolve(resData)
        } else {
          if (resData.error) {
            reject({ from: '/sweb/login/getUserInfo', error: resData.error })
          }
        }
      }).catch(e => {
        reject({from: '/sweb/login/getUserInfo', error: {code: 0, msg: '网络异常，请稍后再试'}})
      })
    })
  },
  getSuppliers ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.supInfoByPassportList(data).then(res => {
        let resData = res.data
        if (resData.ret === 1 && resData.data) {
          commit('setSuppliers', resData.data)
          resolve(resData)
        } else {
          if (resData.error.error) {
            reject({ from: 'login/supInfoByPassportList', error: resData.error.error })
          }
        }
      }).catch(e => {
        reject({from: 'login/supInfoByPassportList', error: {code: 0, msg: '网络异常，请稍后再试'}})
      })
    })
  },
  getFrameSuppliers ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.frameInfoByPassportList(data).then(res => {
        let resData = res.data
        if (resData.ret === 1 && resData.data) {
          commit('setFrameSuppliers', resData.data.supplierQualificationManageList)
          resolve(resData)
        } else {
          if (resData.error.error) {
            reject({ from: 'login/frameInfoByPassportList', error: resData.error.error })
          }
          if (resData.error) {
            reject({ from: 'login/frameInfoByPassportList', error: '未获取到公司主体' })
          }
        }
      }).catch(e => {
        reject({from: 'login/frameInfoByPassportList', error: {code: 0, msg: '网络异常，请稍后再试'}})
      })
    })
  },
  getPurchPhone ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.supplierWaiter(data).then(res => {
        let resData = res.data
        if (resData.ret === 1 && resData.data) {
          commit('setSuppliers', resData.data)
          resolve(resData)
        } else {
          if (resData.error) {
            // reject({ from: 'srmSupInfo/supplierWaiter', error: resData.error })
          }
        }
      }).catch(e => {
        // reject({from: 'srmSupInfo/supplierWaiter', error: {code: 0, msg: '网络异常，请稍后再试'}})
      })
    })
  },
  getServicePhone ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.getPhone(data).then(res => {
        let resData = res.data
        if (resData.ret === 1 && resData.data) {
          commit('setSuppliers', resData.data)
          resolve(resData)
        } else {
          if (resData.error) {
            reject({ from: 'public/getPhone', error: resData.error })
          }
        }
      }).catch(e => {
        reject({from: 'public/getPhone', error: {code: 0, msg: '网络异常，请稍后再试'}})
      })
    })
  },
  login ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.login(data).then(res => {
        let resData = res.data
        if (resData.ret === 1 && resData.data) {
          commit('setLoginSupplier', resData.data)
          resolve(resData)
        } else {
          if (resData.error) {
            reject({ from: 'login/login', error: resData.error })
          }
        }
      }).catch(e => {
        if (e.code && e.code === '0000') {
          reject({ from: 'login/login', error: e })
        } else {
          reject({from: 'login/login', error: {code: 0, msg: '网络异常，请稍后再试'}})
        }
      })
    })
  }
}
const getters = {
  loginSupplier: state => {
    return state.loginSupplier
  }
}
export default new Vuex.Store({
  modules: {
    piaoYiTong, directOrder, helpCenter, order, swebPublic, signImage, bill, certManage, adjustOrder, finance, price, mergeInvoice, goodsCert, paperInvoice, goods, supplierPool, serviceReceipt
  },
  state,
  mutations,
  actions,
  getters,
  strict: debug
})



// WEBPACK FOOTER //
// ./src/store/index.js